import { render, staticRenderFns } from "./UsersSettings.vue?vue&type=template&id=b1292e1c"
import script from "./UsersSettings.vue?vue&type=script&lang=js"
export * from "./UsersSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports